exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".flex-list{padding:4px}.flex-list .input-group__details{min-height:0}.flex-list .menu{margin-left:0}", "", {"version":3,"sources":["/home/circleci/repo/src/components/mobile/ResourcesFilter.vue"],"names":[],"mappings":"AACA,WACE,WAAa,CACd,AACD,iCACE,YAAgB,CACjB,AACD,iBACE,aAAiB,CAClB","file":"ResourcesFilter.vue","sourcesContent":["\n.flex-list {\n  padding: 4px;\n}\n.flex-list .input-group__details {\n  min-height: 0px;\n}\n.flex-list .menu {\n  margin-left: 0px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b7dfa62","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile/ResourcesFilter.vue
// module id = 1363
// module chunks = 18